module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "untitled-1"
    }
  }, [_c('div', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "normal-310-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override9"
  }, [_vm._v("“Melia Ridge” is a work of fiction. The names, characters, locales, and incidents that are depicted in this book are either the product of the author’s imagination or are used fictitiously. Any resemblance of any character within this work to an actual person, living or dead, is purely coincidental. The exceptions are the Oregon, Ireland, and Italian settings.  ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override9"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override9"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override9"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override9"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override9"
  }, [_vm._v("MELIA RIDGE published by: ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override9"
  }, [_vm._v("WILDBLUE PRESS")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override9"
  }, [_vm._v("P.O. Box 102440")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override9"
  }, [_vm._v("Denver, Colorado 80250")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override9"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override9"
  }, [_vm._v("Publisher Disclaimer: Any opinions, statements of fact or fiction, descriptions, dialogue, and citations found in this book were provided by the author, and are solely those of the author. The publisher makes no claim as to their veracity or accuracy, and assumes no liability for the content.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override9"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override9"
  }, [_vm._v("Copyright 2017 by William Florence")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override9"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override9"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced in any form or by any means without the prior written consent of the Publisher, excepting brief quotes used in reviews.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override9"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override9"
  }, [_vm._v("WILDBLUE PRESS is registered at the U.S. Patent and Trademark Offices.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override9"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override9"
  }, [_vm._v("ISBN 978-1-947290-23-5    Trade Paperback")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override9"
  }, [_vm._v("ISBN 978-1-947290-22-8    eBook")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override9"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override9"
  }, [_vm._v("Interior Formatting/Book Cover Design by Elijah Toten ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override9"
  }, [_vm._v("www.totencreative.com"), _c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "calibre_pb_2"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2303bbc8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/copyright.vue
// module id = 63
// module chunks = 0